export const componentStyles = {
    prihvatiButtonStyle: {
        color: 'white',
        fontWeight: 'bold',
        backgroundColor: '#2e7d32',
        "&:hover": {
            backgroundColor: "#520074"
        }
    },
    odustaniButtonStyle: {
        color: 'white',
        fontWeight: 'bold',
        backgroundColor: '#d32f2f',
        "&:hover": {
            backgroundColor: '#520074'
        }
    },
    obrisiButtonStyle: {
        color: 'white',
        fontWeight: 'bold',
        backgroundColor: '#ed6c02',
        "&:hover": {
            backgroundColor: '#520074'
        }
    },
    krajButtonStyle: {
        color: 'white',
        fontWeight: 'bold',
        backgroundColor: '#d32f2f',
        "&:hover": {
            backgroundColor: '#520074'
        }
    },
    primarnaDodjelaButtonStyle: {
        color: 'white',
        fontWeight: 'bold',
        backgroundColor: '#520074',
        "&:hover": {
            backgroundColor: '#520074'
        }
    },
    rezervacijeOduzimanjeButtonStyle: {
        color: 'white',
        fontWeight: 'bold',
        backgroundColor: '#2e7d32',
        "&:hover": {
            backgroundColor: '#520074'
        }
    },
    pregledArhiveButtonStyle: {
        color: 'white',
        fontWeight: 'bold',
        backgroundColor: '#520074',
        "&:hover": {
            backgroundColor: '#520074'
        }
    },
    upitiButtonStyle: {
        color: 'white',
        fontWeight: 'bold',
        backgroundColor: '#520074',
        "&:hover": {
            backgroundColor: '#520074'
        }
    },
    prsOperatoriButtonStyle: {
        color: 'white',
        fontWeight: 'bold',
        backgroundColor: '#520074',
        "&:hover": {
            backgroundColor: '#520074'
        }
    },
    odustaniButtonStyle: {
        color: 'white',
        fontWeight: 'bold',
        backgroundColor: '#d32f2f',
        "&:hover": {
            backgroundColor: '#520074'
        }
    },
    snimiButtonStyle: {
        color: 'white',
        fontWeight: 'bold',
        backgroundColor: '#2e7d32',
        "&:hover": {
            backgroundColor: "#520074"
        }
    }

}